"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipNote = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _excluded = ["note"];
var Note = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1vthhiv0"
} : {
  target: "e1vthhiv0",
  label: "Note"
})("padding:2px 6px;line-height:16px;font-size:10px;font-weight:", _styles.typography.weight.bold, ";color:", _styles.color.lightest, ";box-shadow:0 0 5px 0 rgba(0, 0, 0, 0.3);border-radius:", _styles.spacing.borderRadius.small, "px;white-space:nowrap;pointer-events:none;z-index:-1;background:rgba(0, 0, 0, 0.6);margin:6px;");

var TooltipNote = function TooltipNote(_ref) {
  var note = _ref.note,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Note, rest, note);
};

exports.TooltipNote = TooltipNote;